<template>
  <div class="layout-footer">
    <img :src="logoUrl" alt="Logo" height="20" class="mr-2" />
    <span class="font-medium ml-2">{{ siteTitle }}</span>
  </div>
</template>

<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed, onMounted } from 'vue';
import { useSiteSettings } from '@/composables/useSiteSettings';

const { layoutConfig } = useLayout();
const { siteTitle, loadSiteSettings } = useSiteSettings();

const logoUrl = computed(() => {
  return `/layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`;
});

onMounted(() => {
  loadSiteSettings();
});
</script>
<style lang="scss" scoped></style>
